import styled from "@emotion/styled";
import { GrButton } from "@jnpmedi/grebob/dist/components/buttons/GrButton";
import { GrIcon } from "@jnpmedi/grebob/dist/components/icons/GrIcon";
import { GrTypography } from "@jnpmedi/grebob/dist/components/inputs/GrTypography";
import { GrStack } from "@jnpmedi/grebob/dist/components/layout/GrStack";
import { palette } from "@jnpmedi/grebob/dist/theme/palette";
import { useVersionCheck } from "@newHooks/common/useVersionCheck";
import { useLayoutContext } from "@newHooks/context/layout/layout.context";
import { baseZIndex } from "@assets/theme/baseDefine/baseZIndex";
import { DOCS_COMMON_LANG } from "@maven-msg/lang/docs/common";
import { MvnMessage } from "@maven-msg/lib/Message";

export function NotificationHeader() {
  const { sidebarCollapsed } = useLayoutContext();

  const { isOutdated } = useVersionCheck();

  const handleRefreshButtonClick = () => {
    window.location.reload();
  };

  if (!isOutdated) {
    return null;
  }

  return (
    <NotificationHeaderWrapper sidebarCollapsed={sidebarCollapsed.value}>
      <GrStack gap={8}>
        <GrIcon type="alert-triangle-filled" color="orange050" size={18} />
        <GrTypography type="Content.Subtitle04" color="grey090" style={{ lineHeight: "145%" }}>
          {MvnMessage(DOCS_COMMON_LANG.DOCS_UPDATE_NOTIFICATION_HEADER_DESCRIPTION)}
        </GrTypography>
      </GrStack>

      <GrButton
        startIcon="refresh2"
        color="orange"
        children={MvnMessage(DOCS_COMMON_LANG.REFRESH_NOUN)}
        onClick={handleRefreshButtonClick}
      />
    </NotificationHeaderWrapper>
  );
}

const NotificationHeaderWrapper = styled("header")<{ sidebarCollapsed: boolean }>`
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 24px;
  top: 56px;
  right: 0;
  transition: left ease-in-out 0.23s;
  left: ${({ sidebarCollapsed }) => (sidebarCollapsed ? 200 : 60)}px;
  height: 48px;
  z-index: ${baseZIndex.layout.notificationHeader};
  background: ${palette["orange015"]};
  @media (max-width: 1024px) {
    left: 60px;
  }
`;
